import {createGlobalStyle} from 'styled-components';
import {fontSize, greenTextColor, outlineColor, tabletWidth, wh} from './mixins';

const GlobalStyle = createGlobalStyle`

  @font-face {
  font-family: 'Open Sans';
  src: url("./fonts/Open_Sans/OpenSans-Bold.ttf");
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url("./fonts/Open_Sans/OpenSans-ExtraBold.ttf");
  font-style: normal;
  font-weight: 800;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url("./fonts/Open_Sans/OpenSans-Light.ttf");
  font-style: normal;
  font-weight: 300;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url("./fonts/Open_Sans/OpenSans-Regular.ttf");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  src: url("./fonts/Open_Sans/OpenSans-SemiBold.ttf");
  font-style: normal;
  font-weight: 600;
  font-display: swap;
}

* {
  box-sizing: border-box;
  font-family: Open-Sans, sans-serif !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
}

 body {
    position: relative;
    margin: 0;
    padding: 0;
    font-family: "Open Sans", sans-serif;
    font-weight: 300;
    overflow: hidden;
  }
  
   input[type="text"],
   input[type="tel"],
   input[type="email"],
   input[type="password"],
   input[type="tel"],
   input[type="textarea"],
   input[type="radio"],
   textarea,
   input {
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;
  }
  
    a, input, button {
     font-family: Open-Sans, sans-serif;
   }
  
  a {
    color: #fff;
     
      &:hover,
      &:active {
      color: #fff;
    }
  }

  button:focus {
    outline: none !important;
  }
  
  
  .alert.alert-info {
    width: 90%;
    margin-top: 10px;
  }

 
  //Gooogle Map Global Styles
    
 .gm-style .gm-style-iw-c {
      padding: 0;
      background-color: transparent;
      box-shadow: none;
      border-radius: 22px;
      transform: translate(-50%,-165%);
      max-width: unset !important;
      max-height: unset !important;
      
      
      &:focus {
       outline: none !important;
      }
      
      @media screen and (max-width: ${tabletWidth}) {
        transform: translate(-50%,-145%);
      }
  }
  
  .gm-style-iw-d {
      overflow: hidden !important;
      max-width: unset !important;
      max-height: unset !important;
  }
  
  .gm-ui-hover-effect {
    display: none !important;
  }
  
 .gm-style-iw-t::after {
     width: 0 !important;
  }
  
 
  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom,
  .gmnoprint.gm-bundled-control {
    div {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    .gm-control-active {
      background-color: #fff !important;
      border-radius: 50% !important;
      margin-bottom: 15px !important;
    }
  }

  .gmnoprint {
    z-index: 2000 !important;
  }
  
  //Overriding phone input styles
  
  .PhoneInput {
    width: 100%;
  }
  
  .PhoneInputInput {
    ${wh('100%', '48px')};
    font-weight: 500;
    ${fontSize(16)};
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #323232;
    border: 1px solid #D4D4D4;
    border-radius: 4px;
    margin-top: 10px;
    padding: 14px 16px 14px 60px;
  
    &:focus {
      outline-color: ${outlineColor};
    }
  
    &::placeholder {
      color: #848484;
      font-weight: 300;
    }
   }
   
   .PhoneInputCountry {
      position: absolute;
      top: 22px;
      left: 12px;
   }
  
   .PhoneInputCountryIcon {
    width: 28px;
    height: 22px;
  }
  
  .PhoneInputCountryIcon--border {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
  
  //Material Styles Overriding
  
   .MuiLinearProgress-barColorPrimary {
    background-color: ${greenTextColor} !important;
   }
  
  .carousel-indicators button {
    width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
    background-color: rgba(50, 50, 50, 0.4);
    margin-right: 5px;
    
    &.active {
      background-color: #FBA253;
    }
  }

`;

export default GlobalStyle;